var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5208 10.078L14.3762 12.9326L13.4328 13.876L10.5782 11.0206C9.51599 11.8721 8.19483 12.3352 6.8335 12.3333C3.5215 12.3333 0.833496 9.64531 0.833496 6.33331C0.833496 3.02131 3.5215 0.333313 6.8335 0.333313C10.1455 0.333313 12.8335 3.02131 12.8335 6.33331C12.8354 7.69465 12.3723 9.01581 11.5208 10.078ZM10.1835 9.58331C11.0296 8.71324 11.5021 7.54693 11.5002 6.33331C11.5002 3.75465 9.4115 1.66665 6.8335 1.66665C4.25483 1.66665 2.16683 3.75465 2.16683 6.33331C2.16683 8.91131 4.25483 11 6.8335 11C8.04712 11.0019 9.21342 10.5294 10.0835 9.68331L10.1835 9.58331Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.e3c9f00aa14911ae88a2f9b33b32bce7.svg";
export { ForwardRef as ReactComponent };